export default class StandingGameMetaParticipantsModel {
  public id: string = null;
  public name: string = null;
  public group: string | null = null;
  public image: string | null = null;
  public undecided: boolean = false;
}
